import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';

type Params = {
  idStatement: number;
  rateDate: string;
};

export const changeStatementRate = async (params: Params) => {
  const fetchURL = getM8AdminURL('changeStatementRate');

  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(fetchURL, { method: 'POST', body });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
